import './App.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import basicInformation from './pages/basicInformation/basicInformation';
import personalInformation from './pages/personalInformation/personalInformation';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import ProtectedRoute from './protectedRoute';
import LandingPage from './pages/landingPage/landingPage';
import { useSelector } from 'react-redux';
import FundingSources from './pages/fundingSources/fundingSources';
import Health from './pages/health/health';
import AdditionalInformation from './pages/additionalInformation/additionalInformation';
import { createBrowserHistory } from 'history';


function App() {
  let busyRef = undefined;
  let busyDeep = 0;
  const setBusy = (show) => {
    busyDeep += show ? 1 : -1;
    if (busyRef === null || busyRef === undefined) {
      busyRef = document.getElementById('referral-busy');
    }
    busyRef.style.display = show || busyDeep > 0 ? 'block' : 'none';
  };

  const history = createBrowserHistory({
    basename: process.env.REACT_APP_BASENAME
  });

  const authData = useSelector((state) => state.authData);
  return (
    <div className='App'>
      <Router history={history} basename={process.env.REACT_APP_BASENAME}>
        <Switch>
          <Route path='/' exact component={LandingPage} />
          <ProtectedRoute
            path='/basicInformation'
            component={basicInformation}
            auth={authData}
            setBusy={setBusy}
          />
          <ProtectedRoute
            path='/personalInformation'
            component={personalInformation}
            auth={authData}
            setBusy={setBusy}
          />
          <ProtectedRoute
            path='/fundingSources'
            component={FundingSources}
            auth={authData}
            setBusy={setBusy}
          />
          <ProtectedRoute
            path='/health'
            component={Health}
            auth={authData}
            setBusy={setBusy}
          />
          <ProtectedRoute
            path='/additionalInformation'
            component={AdditionalInformation}
            auth={authData}
            setBusy={setBusy}
          />
          <Route path='*' component={() => '404 not found page'} />
        </Switch>
      </Router>
      <div id='referral-busy' ref={e => busyRef = e}>
        <div className='wait'></div>
      </div>
    </div>
  );
}

export default App;
